const thunkStatuses = ['pending', 'fulfilled', 'rejected'];

export const addExtraReducer = (builder, thunk, reducer) => {
  // status ip 'pending' | 'rejected' | 'fulfilled'
  for (const [status] of Object.entries(reducer)) {
    if (thunkStatuses.includes(status)) {
      builder.addCase(thunk[status], reducer[status]);
    }
  }
};
